import { render, staticRenderFns } from "./LabelsList.vue?vue&type=template&id=9d539e96&scoped=true"
import script from "./LabelsList.vue?vue&type=script&lang=js"
export * from "./LabelsList.vue?vue&type=script&lang=js"
import style0 from "./LabelsList.vue?vue&type=style&index=0&id=9d539e96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d539e96",
  null
  
)

export default component.exports